import { render, staticRenderFns } from "./Forecasts.vue?vue&type=template&id=2bf66ab0&scoped=true&"
import script from "./Forecasts.vue?vue&type=script&lang=js&"
export * from "./Forecasts.vue?vue&type=script&lang=js&"
import style0 from "./Forecasts.vue?vue&type=style&index=0&id=2bf66ab0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bf66ab0",
  null
  
)

export default component.exports